module.exports = __webpack_public_path__ + "img/help.af4017cb.svg";